export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 11_11.4c1afd6d.jpg";